/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_Th3Inputs */

const en_mk_cmp_multica_th3 = /** @type {(inputs: Mk_Cmp_Multica_Th3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We found no formal approval mechanism.`)
};

const id_mk_cmp_multica_th3 = /** @type {(inputs: Mk_Cmp_Multica_Th3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak kami temukan mekanisme approval formal.`)
};

/**
* | output |
* | --- |
* | "We found no formal approval mechanism." |
*
* @param {Mk_Cmp_Multica_Th3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_th3 = /** @type {((inputs?: Mk_Cmp_Multica_Th3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_Th3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_th3(inputs)
	return en_mk_cmp_multica_th3(inputs)
});